import React from 'react';
import { Row, Column } from '@upgrade/react-components';

import { toHtmlSanitize } from '../../utils/remark-html';

import { Section, TextLarge } from '../common/styles';

import { StyledImage, AboutTextWrapper } from './styles';

import Fluid from '../Fluid';
import { Heading } from '../common/TypographyPublicSite';

export default ({ whoWeAre: { title, image, imageWidth, imageHeight, text }, borderless }) => (
  <Section {...{ borderless }} padding="xs">
    <Fluid>
      <Row gutter="large" xsHorizontalAlign="center">
        <Column xs={12}>
          {title && (
            <Heading as="h2" size="sm" className="hidden-sm">
              {title}
            </Heading>
          )}
          <Row xsHorizontalAlign="center" gutter="large">
            <Column sm={12} md={4} xsHorizontalAlign="center">
              <StyledImage
                className="section--lg"
                srcSet={image}
                width={imageWidth}
                height={imageHeight}
                aria-hidden="true"
                alt=""
              />
            </Column>
            <Column sm={12} md={8} xsHorizontalAlign="start">
              {title && (
                <Heading as="h2" size="sm" marginBottom="2xl" className="hidden visible-sm">
                  {title}
                </Heading>
              )}
              <AboutTextWrapper>
                <TextLarge dangerouslySetInnerHTML={{ __html: toHtmlSanitize(text) }} />
              </AboutTextWrapper>
            </Column>
          </Row>
        </Column>
      </Row>
    </Fluid>
  </Section>
);
